import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import PaymentStepsRecurring from '../PaymentSteps/PaymentStepsRecurring';
import PaymentStepsForOtm from '../PaymentSteps/PaymentStepsForOtm';
import PaymnetTabsRecurring from '../PaymentTabs/PaymentTabsRecurring';
import PaymentDetails from './Components/CommonDetails/PaymentDetails';
import PlanAccordion from './Components/CommonDetails/PlanAccordion';
import PaymentAccordionRecurring from '../PaymentTabs/Components/PaymentAccordionRecurring';
import PaymentError from '../PaymentSteps/PaymentError';
import CustomizedDialogs from '../../Shared/CustomDialogs';
import SkipAutoPay from '../../Shared/SkipAutoPay';

function PaymnetView({apiData, otmpayment}) {
   const [isMobileView, setIsMobileView] = useState(false);
   const [showSkipAutoPay, setShowSkipAutoPay] = useState(false);	
   const [showDialog, setShowDialog] = useState(false);	

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 820);
        };
	handleResize();
	window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
     useEffect(() => {
     
        setShowDialog(apiData.isSkipAutoRegister);
     }, [apiData]);
    
    const certifiedLogosStyle = {
      fontSize: '12px',
      color: '#0065FF',	
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'space-between', // Align items to the edges
      alignItems: 'center', // Vertically center items
      padding: '10px',
      
    };
    


return (
    <>
        <div className='mt-1 paymnet-mode md:mt-10'>
            <ul className='payment-list-main'>
            <li className='sm:block lg:block lg:w-5/1 mr-8 align-top col-left-panel'>
                  {otmpayment ? <PaymentStepsForOtm/> : <PaymentStepsRecurring/>}
                   
                   {apiData.retry && <PaymentError retry = {apiData.retry}/>}
                    <div className='hidden md:block mt-6 bg-slate-100 debit-card-tab'>
                        {!isMobileView && <PaymnetTabsRecurring/>}
                        
                           <div className='block sm:hidden '>
                             {/* {isMobileView && <PlanAccordion />} */}
                            </div>
                       
                    </div>
                     {!isMobileView && (
                      <div style={certifiedLogosStyle} className="certified-logos hideSmall">
                          <p className="left">
                            <a href="https://www.policybazaar.com/legal-and-admin-policies/" target="_blank" rel="noopener noreferrer">
                              Privacy Policy
                            </a>
                            {'  |  '}
                            <a href="https://www.policybazaar.com/legal-and-admin-policies/#termsofuse" target="_blank" rel="noopener noreferrer">
                              Terms & Conditions
                            </a>
                            {'  |  '}
                            <a href="https://payment.policybazaar.com/pay/faq.jsp" target="_blank" rel="noopener noreferrer">
                              FAQ
                            </a>
                          </p>
                          <p className="right rightOne">
                            <a href="https://seal.gtisec.com/policybazaar" target="_blank" rel="noopener noreferrer">
                          
                              <img
                                src="./images/pci-dss-certified@2x.png"
                                alt="PCI DSS Certified"
                                width="84"
                              />
                            </a>
                          </p>
                    </div>
            )}
                </li>
                <li className='w-full  md:full lg:inline-block lg:w-2/5 col-right-panel'>
                    {!isMobileView &&  <PlanAccordion/>}
                    {!isMobileView && showDialog && (<button  onClick={() => setShowSkipAutoPay(true)} className='skip-autopay-btn'>Skip Autopay Registration</button> )}
                </li>
                <li className='block sm:block lg:hidden'>
                 {isMobileView &&  <PaymentAccordionRecurring showDialog={showDialog} otmpayment={otmpayment} />}
                </li>
            </ul>
        </div>
       
         
     {showSkipAutoPay ? <CustomizedDialogs  className='razor-pay-dialog'  open={showSkipAutoPay} handleClose={() => setShowSkipAutoPay(false)}>
        <SkipAutoPay  handleCloseDialog={() => setShowSkipAutoPay(false)}/>
      </CustomizedDialogs>
      : null}
    </>
);
}

export default PaymnetView;

